import { render, staticRenderFns } from "./PriceBreakdown.vue?vue&type=template&id=185c0fa6&scoped=true&"
import script from "./PriceBreakdown.vue?vue&type=script&lang=js&"
export * from "./PriceBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PriceBreakdown.vue?vue&type=style&index=0&id=185c0fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c0fa6",
  null
  
)

export default component.exports